import { render } from "./GroupManagementMotifsDialog.vue?vue&type=template&id=19c5da4b"
import script from "./js/groupManagementMotifsDialog.js?vue&type=script&lang=js&external"
export * from "./js/groupManagementMotifsDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__